import { Badge } from "@aeo/core/components";

export const NABadge = () => (
  <Badge size="sm" color="danger" variant="subtle">
    NU SE APLICĂ
  </Badge>
);
